import React from "react";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const Gate = ({ title, body }) => {
  const { openAuth } = useAuth();
  return (
  <div
    className="max-w-lg mx-auto text-center py-28 px-6"
    data-testid="route-auth-gate"
  >
    <span className="inline-flex w-14 h-14 rounded-full bg-[#f5f4f0] items-center justify-center mb-6">
      <Lock className="w-6 h-6 text-[#c23c28]" />
    </span>
    <h2 className="font-serif text-3xl md:text-4xl tracking-tight text-[#14140f] mb-3">
      {title}
    </h2>
    <p className="text-[#4e6073] mb-7">{body}</p>
    <Button
      onClick={openAuth}
      data-testid="gate-signin-btn"
      className="bg-[#ff7360] hover:bg-[#e85a46] text-[#14140f] rounded-full px-6"
    >
      Sign in to continue
    </Button>
  </div>
  );
};

const Spinner = () => (
  <div className="flex items-center justify-center py-32">
    <Loader2 className="w-8 h-8 text-[#c23c28] animate-spin" />
  </div>
);

export const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user)
    return (
      <Gate
        title="Your journey awaits"
        body="Sign in to track what you've learned, save notes and follow learning tracks."
      />
    );
  return children;
};

export const RequireRole = ({ roles, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user)
    return (
      <Gate
        title="Sign in required"
        body="This area is reserved for signed-in members."
      />
    );
  if (!roles.includes(user.role))
    return (
      <Gate
        title="Restricted area"
        body="You don't have the role required to view this page."
      />
    );
  return children;
};
